
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import BottomNav from '../../components/feature/BottomNav';

const ProfilePage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [user] = useState({
    name: 'أحمد محمد',
    email: 'ahmed.mohamed@email.com',
    phone: '+966 50 123 4567',
    avatar: 'https://public.readdy.ai/ai/img_res/cacd09d1cc8508fdea6dcbca8cff3c95.jpg'
  });

  const handleBackClick = () => {
    navigate('/home');
  };

  const handleSettingsClick = () => {
    // يمكن إضافة صفحة الإعدادات لاحقاً
    console.log('Settings clicked');
  };

  const handleEditProfile = () => {
    // يمكن إضافة صفحة تعديل الملف الشخصي لاحقاً
    console.log('Edit profile clicked');
  };

  const handleMenuItemClick = (title: string) => {
    if (title === 'اللغة') {
      navigate('/language');
    } else {
      // يمكن إضافة صفحات أخرى لاحقاً
      console.log(`${title} clicked`);
    }
  };

  const handleLogout = () => {
    // تسجيل الخروج والعودة لصفحة تسجيل الدخول
    navigate('/auth/login');
  };

  const menuItems = [
    { icon: 'ri-user-line', title: 'المعلومات الشخصية', subtitle: 'تحديث بياناتك الشخصية' },
    { icon: 'ri-notification-line', title: 'الإشعارات', subtitle: 'إدارة إعدادات الإشعارات' },
    { icon: 'ri-shield-check-line', title: 'الأمان والخصوصية', subtitle: 'كلمة المرور والأمان' },
    { icon: 'ri-credit-card-line', title: 'طرق الدفع', subtitle: 'إدارة البطاقات والمحافظ' },
    { icon: 'ri-coupon-line', title: 'العروض والخصومات', subtitle: 'كوبونات الخصم المتاحة' },
    { icon: 'ri-customer-service-line', title: 'خدمة العملاء', subtitle: 'تواصل معنا للمساعدة' },
    { icon: 'ri-question-line', title: 'الأسئلة الشائعة', subtitle: 'إجابات للأسئلة المتكررة' },
    { icon: 'ri-file-text-line', title: 'الشروط والأحكام', subtitle: 'اقرأ شروط الاستخدام' },
    { icon: 'ri-global-line', title: 'اللغة', subtitle: 'تغيير لغة التطبيق' }
  ];

  const stats = [
    { label: 'الرحلات المكتملة', value: '12', icon: 'ri-flight-takeoff-line' },
    { label: 'النقاط المكتسبة', value: '2,450', icon: 'ri-star-line' },
    { label: 'المبلغ المدخر', value: '850 ر.س', icon: 'ri-money-dollar-circle-line' }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-white shadow-sm fixed top-0 left-0 right-0 z-10 h-16">
        <div className="flex items-center justify-between h-full px-4">
          <button 
            onClick={handleBackClick}
            className="w-10 h-10 flex items-center justify-center rounded-full hover:bg-gray-100 flex-shrink-0"
          >
            <i className="ri-arrow-right-line text-xl text-gray-700"></i>
          </button>
          <h1 className="text-lg font-semibold text-gray-900 truncate mx-4">الملف الشخصي</h1>
          <button 
            onClick={handleSettingsClick}
            className="w-10 h-10 flex items-center justify-center rounded-full hover:bg-gray-100 flex-shrink-0"
          >
            <i className="ri-settings-line text-xl text-gray-700"></i>
          </button>
        </div>
      </div>

      {/* Content */}
      <div className="pt-16 pb-20">
        {/* Profile Header */}
        <div className="bg-white p-6">
          <div className="flex items-center space-x-4 space-x-reverse mb-6">
            <img
              src={user.avatar}
              alt={user.name}
              className="w-20 h-20 rounded-full object-cover"
            />
            <div className="flex-1">
              <h2 className="text-xl font-semibold text-gray-900">{user.name}</h2>
              <p className="text-gray-600 text-sm">{user.email}</p>
              <p className="text-gray-600 text-sm">{user.phone}</p>
            </div>
            <button 
              onClick={handleEditProfile}
              className="w-10 h-10 flex items-center justify-center rounded-full bg-blue-100 hover:bg-blue-200"
            >
              <i className="ri-edit-line text-blue-600"></i>
            </button>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-3 gap-4">
            {stats.map((stat, index) => (
              <div key={index} className="text-center">
                <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-2">
                  <i className={`${stat.icon} text-blue-600`}></i>
                </div>
                <div className="text-lg font-bold text-gray-900">{stat.value}</div>
                <div className="text-xs text-gray-600">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Menu Items */}
        <div className="p-4 space-y-2">
          {menuItems.map((item, index) => (
            <button
              key={index}
              onClick={() => handleMenuItemClick(item.title)}
              className="w-full bg-white rounded-xl p-4 shadow-sm hover:bg-gray-50 transition-colors"
            >
              <div className="flex items-center space-x-3 space-x-reverse">
                <div className="w-10 h-10 bg-gray-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className={`${item.icon} text-gray-600`}></i>
                </div>
                <div className="flex-1 text-right">
                  <h3 className="font-medium text-gray-900">{item.title}</h3>
                  <p className="text-sm text-gray-500">{item.subtitle}</p>
                </div>
                <i className="ri-arrow-left-s-line text-gray-400"></i>
              </div>
            </button>
          ))}
        </div>

        {/* Logout Button */}
        <div className="p-4">
          <button 
            onClick={handleLogout}
            className="w-full bg-red-50 text-red-600 py-3 rounded-xl font-medium hover:bg-red-100 transition-colors flex items-center justify-center space-x-2 space-x-reverse"
          >
            <i className="ri-logout-box-line"></i>
            <span>تسجيل الخروج</span>
          </button>
        </div>

        {/* App Version */}
        <div className="text-center text-gray-400 text-sm pb-4">
          إصدار التطبيق 1.0.0
        </div>
      </div>

      {/* Bottom Navigation */}
      <BottomNav />
    </div>
  );
};

export default ProfilePage;
